import React from "react";
import "chart.js/auto";
import { Bar } from "react-chartjs-2";
import { ConsumptionBucket, BucketSize } from "./types";
import { formatBucketLabel } from "./helpers";

interface Props {
  buckets: ConsumptionBucket[];
  bucketSize: BucketSize;
}

const CreditsBarChart: React.FC<Props> = ({ buckets, bucketSize }) => {
  const data = {
    labels: buckets.map((bucket) =>
      formatBucketLabel(bucket.periodStart, bucketSize)
    ),
    datasets: [
      {
        label: "Credits consumed",
        data: buckets.map((bucket) => bucket.credits),
        backgroundColor: "#1f7a8c",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      x: { title: { display: true, text: "Period" } },
      y: {
        beginAtZero: true,
        title: { display: true, text: "Credits consumed" },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default CreditsBarChart;
